<template>
    <div>
        <l-map
            v-if="centerDefault"
            ref="mapRef"
            id="mapId"
            :zoom="zoomDefault"
            :center="centerDefault"
            class="map-height"
            @moveend="moveOrZoom"
            @zoomlevelschange="moveOrZoom"
        >
            <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>

            <l-marker
                v-for="(marker, markerKey) in markers"
                v-if="marker.latitude && marker.longitude"
                :key="markerKey"
                :lat-lng="{lat: (marker.latitude), lng: (marker.longitude)}"
                :options="{draggable: draggable}"
                @dragend="updatePosition($event, markerKey)"
            >
                <l-icon
                    :icon-size=[48,50]
                    :popup-anchor=[0,0]
                    :icon-url="'/images/pin-map/small-here.png'"
                    :shadow-url="'/images/pin-map/marker-shadow.png'">
                </l-icon>

                <l-popup v-if="marker.name" class="map-marker">
                    <a :href="marker.link" target="_top" :title="marker.name" class="fw-bold text-capitalize">{{ marker.name }}</a>

                    <div class="d-flex my-1">
                        <div class="review-content-stars">
                            <div class="review-content-stars-mark" :style="'width:'+parseFloat(marker.average)*20+'%'">
                                <img src="/images/star-system--small.png" :alt="marker.average+' sur 5'" :title="marker.average+' sur 5'">
                            </div>
                        </div>
                        <p class="darkgrey my-0 ms-2">{{ marker.number_of_notes }} avis</p>
                    </div>

                    <p class="darkgrey text-capitalize my-0">{{ marker.address }}</p>
                    <p class="darkgrey text-capitalize my-0">{{ marker.city.postal_code }} {{ marker.city.name }}</p>
                </l-popup>
            </l-marker>
        </l-map>
    </div>
</template>

<script>
import 'leaflet/dist/leaflet.css';
import {LMap, LTileLayer, LMarker, LIcon, LPopup} from 'vue2-leaflet';

export default {
    name: 'map-component',

    props: {
        center: Array,
        draggable: Boolean,
        ids: Array,
        listMarkers: Array,
        pois: Array,
        reloadOnZoom: {type: Boolean, default: false},
        showModal: {type: Boolean, default: false},
        zoom: Number,
    },

    components: {
        LMap,
        LTileLayer,
        LMarker,
        LIcon,
        LPopup
    },

    data() {
        return {
            ajaxReq: '',
            attribution: '&copy; <a target="_blank" href="https://osm.org/copyright">OpenStreetMap</a> contributors',
            centerDefault: null,
            errorInformation: '',
            firstLoad: true,
            markers: [],
            maxZoom: 20,
            minZoom: 7,
            showMarkers: false,
            url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            zoomDefault: this.zoom ? this.zoom : 7,
        }
    },

    mounted() {
        this.centerDefault = [48.862673415603616, 2.295191664223299];
        this.getPois();

        setTimeout(() => {
            if (this.$refs.mapRef) {
                this.$refs.mapRef.mapObject.invalidateSize();
            }
        }, 100);

        if (this.showModal) {
            this.listenEventModel();
        }
    },

    watch: {
        listMarkers: function (newList) {
            this.markers = newList;
        },

        center: function (newCenter) {
            this.centerDefault = newCenter;
        },

        pois: function(newVal, oldVal) {
            this.getPois();
                console.log('Prop changed: ', newVal, ' | was: ', oldVal)
        }
    },

    methods: {
        listenEventModel() {
            let myModal = document.getElementById('seeMap')
            let t = this;

            myModal.addEventListener('show.bs.modal', function () {
                setTimeout(() => {
                    t.centerDefault = t.center ? t.center : [48.862673415603616, 2.295191664223299];
                    if (t.$refs.mapRef) {
                        t.$refs.mapRef.mapObject.invalidateSize();
                        t.firstLoad = false; // Permet de savoir si c'est le premier chargement de la modale
                        t.$forceUpdate(); // Force la mise à jour des datas
                    }
                }, 2000);
            })
        },

        async getPois() {
            try {
                if (this.pois) {
                    for (let marker of this.pois) {
                        if(marker.poi && marker.poi.latitude && marker.poi.longitude){
                            if(this.center) {
                                this.centerDefault = this.center;
                            } else {
                                this.centerDefault = [marker.poi.latitude, marker.poi.longitude];
                            }

                            this.markers.push({
                                id: marker.id,
                                name: marker.poi.nameCleaned,
                                address: marker.poi.address,
                                latitude: marker.poi.latitude,
                                longitude: marker.poi.longitude,
                                link: marker.poi.link,
                                number_of_notes: marker.poi.number_of_notes,
                                average: marker.poi.average,
                                city: {
                                    name: marker.poi.city.name,
                                    postal_code: marker.poi.city.postal_code
                                },
                            });
                        }
                    }
                }

                if (this.ids) {
                    const response = await axios.post('/api/v1/maps',
                        {
                            'ids': this.ids
                        });

                    if (response && response.data.data) {
                        for (let marker in response.data.data) {
                            this.markers.push({
                                id: response.data.data[marker]['id'],
                                name: response.data.data[marker]['name'],
                                address: response.data.data[marker]['address'],
                                latitude: response.data.data[marker]['latitude'],
                                longitude: response.data.data[marker]['longitude'],
                                link: response.data.data[marker]['link'],
                                number_of_notes: response.data.data[marker]['number_of_notes'],
                                city: {
                                    name: response.data.data[marker]['city']['name'],
                                    postal_code: response.data.data[marker]['city']['postal_code']
                                },
                            });
                        }
                    }
                }

                if (this.listMarkers) {
                    for (let marker in this.listMarkers) {
                        this.markers.push({
                            latitude: this.listMarkers[marker].latitude,
                            longitude: this.listMarkers[marker].longitude
                        });
                    }
                }

            } catch (error) {
                console.log(error);
            }
        },

        async moveOrZoom() {
            // Min Zoom 11
            let map = this.$refs.mapRef.mapObject;
            let currentZoom = map.getZoom();
            let getBound = map.getBounds();
            let ne = getBound._northEast;
            let sw = getBound._southWest;
            let nw = {lat: ne.lat, lng: sw.lng};
            let se = {lat: sw.lat, lng: ne.lng};
            if (currentZoom >= 11 && ne.lat !== sw.lat && !this.firstLoad) {
                if (this.ajaxReq) {
                    this.ajaxReq.cancel('stop');
                }
                this.ajaxReq = axios.CancelToken.source();

                await axios.post(
                    '/api/v1/pois/markers',
                    {
                        ne: ne,
                        sw: sw,
                        nw: nw,
                        se: se,
                        pois: this.markers.map(marker => marker.id)
                    },
                    {
                        cancelToken: this.ajaxReq.token,
                    })
                    .then(response => {
                        if (response.data.error) {
                            this.errorInformation = response.data.error;
                        } else {
                            if(response.data.length){
                                response.data.forEach(marker => {
                                   this.markers.push(marker);
                                });
                            }
                            this.errorInformation = '';
                        }
                    })
                    .catch(err => {
                        if (axios.isCancel(err)) {
                            return "axios request cancelled";
                        }
                        return err;
                    });
            }
        },

        updatePosition(event) {
            this.$emit('updateCoordinates', {
                latitude: event.target._latlng.lat,
                longitude: event.target._latlng.lng
            })
        }
    }
}
</script>
